import React from "react";
import { Link } from "react-router-dom";

const Sitemap = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* Title */}
        <div className="text-center mb-14">
          <h1 className="text-4xl font-bold text-[#0c5a87] mb-3">
            Website Sitemap
          </h1>
          <p className="text-gray-600">
            Explore all important pages and ERP location services available on Gurukul ERP.
          </p>
        </div>

        {/* MAIN PAGES */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-10">
          <h2 className="text-2xl font-semibold text-orange-500 mb-6">
            Main Pages
          </h2>

          <div className="grid md:grid-cols-4 gap-4 text-gray-700">
            <Link to="/" className="hover:text-blue-600 hover:underline">Home</Link>
            <Link to="/about" className="hover:text-blue-600 hover:underline">About Us</Link>
            <Link to="/contact" className="hover:text-blue-600 hover:underline">Contact</Link>
            <Link to="/SchoolERP" className="hover:text-blue-600 hover:underline">School ERP Software</Link>
          </div>
        </div>


        {/* STATES */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-10">
          <h2 className="text-2xl font-semibold text-orange-500 mb-6">
            School ERP by State And city
          </h2>

          <div className="grid md:grid-cols-3 gap-6 text-gray-700">

            <div className="space-y-2">
              <Link to="/SchoolERP/haryana" className="block hover:text-blue-600">Haryana</Link>
              <Link to="/SchoolERP/uttar-pradesh" className="block hover:text-blue-600">Uttar Pradesh</Link>
              <Link to="/SchoolERP/rajasthan" className="block hover:text-blue-600">Rajasthan</Link>
              <Link to="/SchoolERP/punjab" className="block hover:text-blue-600">Punjab</Link>
            </div>

            <div className="space-y-2">
              <Link to="/SchoolERP/haryana/sirsa" className="block hover:text-blue-600">sirsa</Link>
              <Link to="/SchoolERP/uttar-pradesh/lucknow" className="block hover:text-blue-600">Lucknow</Link>
              <Link to="/SchoolERP/uttar-pradesh/prayagraj" className="block hover:text-blue-600">Prayagraj</Link>
            </div>

            <div className="space-y-2">
              <Link to="/SchoolERP/punjab/amritsar" className="block hover:text-blue-600">Amritsar</Link>
              <Link to="/SchoolERP/punjab/ludhiana" className="block hover:text-blue-600">Ludhiana</Link>
              <Link to="/SchoolERP/rajasthan/jaipur" className="block hover:text-blue-600">Jaipur</Link>
            </div>

          </div>
        </div>


        {/* CITY PAGES */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          <h2 className="text-2xl font-semibold text-orange-500 mb-6 ">
            Popular City ERP Pages
          </h2>

          <div className="grid md:grid-cols-4 gap-6 text-gray-700">

            <div className="space-y-2">
              <Link to="/SchoolERP/haryana/gurugram" className="block hover:text-blue-600">Gurugram</Link>
              <Link to="/SchoolERP/haryana/faridabad" className="block hover:text-blue-600">Faridabad</Link>
            </div>

            <div className="space-y-2">
              <Link to="/SchoolERP/haryana/hisar" className="block hover:text-blue-600">Hisar</Link>
              <Link to="/SchoolERP/uttar-pradesh/kanpur" className="block hover:text-blue-600">Kanpur</Link>
            </div>

            <div className="space-y-2">
              <Link to="/SchoolERP/punjab/bathinda" className="block hover:text-blue-600">Bathinda</Link>
              <Link to="/SchoolERP/haryana/rohtak" className="block hover:text-blue-600">Rohtak</Link>
              <Link to="/SchoolERP/Bengaluru" className="block hover:text-blue-600">Bengaluru</Link>
            </div>

            <div className="space-y-2">
              <Link to="/SchoolERP/rajasthan/bikaner" className="block hover:text-blue-600">Bikaner</Link>
              <Link to="/SchoolERP/uttar-pradesh/noida" className="block hover:text-blue-600">Noida</Link>
              <Link to="/SchoolERP/delhi" className="block hover:text-blue-600">Delhi</Link>
              
            </div>
              
              <div className="bg-white rounded-xl shadow-sm p-8">
          <h2 className="text-2xl font-semibold text-orange-500 mb-6 text-center">
            Anthor Page
          </h2>
          <div className="grid md:grid-cols-4 gap-6 text-gray-700">

            <div className="space-y-2">
              <Link to="/best-attendance-erp-software-india" className="block hover:text-blue-600">Attendance</Link>
              
              <Link to="/top-school-erp-software-india" className="block hover:text-blue-600">SchoolErp</Link>
            </div>
            </div>
               </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Sitemap;